import React from 'react';
import PropTypes from 'prop-types';
import More from './Button/More';

export default (WrappedComponent, {
	length = 7
}) => {
	class WithMore extends React.PureComponent {
		state = {
			opened: false
		};

		onClick = () => this.setState(state => ({ opened: !state.opened }));

		render() {
			let { whenClosed, whenOpened, items, ...props } = this.props;
			let numberOfItems = items.length;

			if (!this.state.opened) {
				items = items.slice(0, 7);
			}

			return <>
				<WrappedComponent {...props} items={items} opened={this.state.opened} />
				{numberOfItems > length && <More
					whenClosed={whenClosed}
					whenOpened={whenOpened}
					opened={this.state.opened}
					onClick={this.onClick}
				/>}
			</>
		}
	}

	WithMore.displayName = `WithMore(${(WrappedComponent.displayName || WrappedComponent.name || 'Component')})`;
	WithMore.propTypes = {
		whenClosed: PropTypes.string.isRequired,
		whenOpened: PropTypes.string.isRequired,
		items: PropTypes.array.isRequired
	};
	WithMore.defaultProps = {
		whenClosed: 'Všechny strany',
		whenOpened: 'Méně stran'
	};

	return WithMore;
};
